import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';

@Component({
    components: {},
})
export default class SBPagetop extends Mixins(SBComponentVue) {
    public click() {
        let element: HTMLElement;
        if (document.scrollingElement) {
            element = <HTMLElement>document.scrollingElement;
        } else if (navigator.userAgent.toLowerCase().match(/webkit|msie 5/)) {
            element = document.body;
        } else {
            element = document.documentElement;
        }

        let remove = () => {
            window.removeEventListener("mousedown", ondown);
            window.removeEventListener("touchstart", ondown);
        }

        let ondown = () => {
            clearTimeout(timeout);
            remove();
        }
        window.addEventListener("mousedown", ondown);
        window.addEventListener("touchstart", ondown);

        // 3次関数補間 : 位置を決定する関数 
        let movefunc = (t: number) => {
            return t * t * (3 - 2 * t);
        }

        let start = element.scrollTop;
        let maxcount = element.scrollTop / 40;
        let count = 0;
        let timeout = 0;
        let func = () => {
            count += 1;
            if (count < maxcount) {
                element.scrollTop = start * (1 - movefunc(count / maxcount));
                timeout = setTimeout(func, 10);
            } else {
                element.scrollTop = 0;
                remove();
            }
        }
        timeout = setTimeout(func, 0);
    }
}
